import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import type { ProfileConfigDto } from '../interfaces/profile-config-dto';
import { hostsConfig } from '../utils';

export default abstract class ProfileConfigDao {
  static async getProfileConfig(env: Environment) {
    const url = hostsConfig[env].profileServiceUrl;
    const { data } = await axios.get<ProfileConfigDto>(`${url}/configurations`);
    return data;
  }
}
